import React from 'react';
import styles from './Lozenge.less';
import cx from 'classnames';

type LozengeAppearances = 'default' | 'transparent' | 'transparent-dark';

const toCamelCase = (str: string) =>
  str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
export interface LozengeProps {
  appearance?: LozengeAppearances;
  color?: 'green' | 'blue' | 'purple' | 'gray';
  verticallyBottom?: boolean;
  inlineFlex?: boolean;
}

export const Lozenge: React.FunctionComponent<LozengeProps> = ({
  appearance = 'default',
  color = 'gray',
  verticallyBottom,
  inlineFlex,
  children,
}) => (
  <span
    className={cx(
      styles.lozenge,
      styles[color],
      styles[toCamelCase(appearance)],
      verticallyBottom && styles.verticallyBottom,
      inlineFlex && styles.inlineFlex,
    )}
  >
    {children}
  </span>
);
